import { CancelShipmentReasonModel } from '../models/CancelShipmentReasonModel'
import { CancelShipmentReasonsFilterModel } from '../models/CancelShipmentReasonsFilterModel'
import { CancelShipmentReasonMiniModel } from '../models/CancelShipmentReasonMiniModel'
import type { CancelShipmentReasonsFilterEntity } from '../../domain/entities/CancelShipmentReasonsFilterEntity'
import type { CancelShipmentReasonMiniEntity } from '../../domain/entities/CancelShipmentReasonMiniEntity'
import { CancelShipmentReasonsService } from '@/backend/market'
import type { CancelShipmentReasonEntity } from '../../domain/entities/CancelShipmentReasonEntity'
import { CreateUpdateCancelShipmentReasonEntity } from '../../domain/entities/CreateUpdateCancelShipmentReasonEntity'
import { CreateUpdateCancelShipmentReasonModel } from '../models/CreateUpdateCancelShipmentReasonModel'
import type { CancelShipmentReasonRepository } from '../../domain/repositories/CancelShipmentReasonRepository'

export class CancelShipmentReasonRepositoryImpl implements CancelShipmentReasonRepository {
  async getCancelShipmentReasons(
    filterData: CancelShipmentReasonsFilterEntity
  ): Promise<CancelShipmentReasonMiniEntity[] | { error: true }> {
    try {
      const cancelShipmentReasonsFilterModel = new CancelShipmentReasonsFilterModel(filterData)
      const response = await CancelShipmentReasonsService.getCancelShipmentReasonsAdmin(
        cancelShipmentReasonsFilterModel
      )
      const cancelShipmentReasonModels = response.cancelShipmentReasons?.map(
        (reason) => new CancelShipmentReasonMiniModel(reason)
      )
      return cancelShipmentReasonModels ?? []
    } catch {
      return { error: true }
    }
  }
  async getCancelShipmentReasonById(
    id: number
  ): Promise<CancelShipmentReasonEntity | { error: true }> {
    try {
      const response = await CancelShipmentReasonsService.getCancelShipmentReasonAdmin({
        id
      })
      const cancelShipmentReasonModel = new CancelShipmentReasonModel(response)
      return cancelShipmentReasonModel
    } catch {
      return { error: true }
    }
  }
  async createCancelShipmentReason(
    data: CreateUpdateCancelShipmentReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateCancelShipmentReasonModel = new CreateUpdateCancelShipmentReasonModel(data)
    try {
      await CancelShipmentReasonsService.postCancelShipmentReasonAdmin({
        requestBody: createUpdateCancelShipmentReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async updateCancelShipmentReason(
    id: number,
    data: CreateUpdateCancelShipmentReasonEntity
  ): Promise<{ success: true } | { error: true }> {
    const createUpdateCancelShipmentReasonModel = new CreateUpdateCancelShipmentReasonModel(data)
    try {
      await CancelShipmentReasonsService.putCancelShipmentReasonAdmin({
        id,
        requestBody: createUpdateCancelShipmentReasonModel
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
  async deleteCancelShipmentReason(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await CancelShipmentReasonsService.deleteCancelShipmentReasonAdmin({
        id
      })
      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
